import { Injectable } from '@angular/core';
import { Request, Headers, Response } from '@angular/http';
import { HttpClient } from '../../../../services/http.service';
import { AppConstants } from '../../../../app.constants';
import { LocalStorageService } from 'ng2-webstorage';
import { Observable } from 'rxjs/Rx';
@Injectable()
export class CourseHService {
    private token: string;
    private schoolId: string;
    constructor(private httpClient: HttpClient, private appConstants: AppConstants, private localStorage: LocalStorageService) {
        this.token = this.localStorage.retrieve('Token');
        this.schoolId = this.localStorage.retrieve('SchoolId');

    }
  
//-------------------------------------------------------------------------------------------------//
public getHigherEdChildNameList(course_id, batch_id): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetHiEduChildInfoBySchoolCourseBatch" +'?Schoolid=' + this.schoolId + '&courseId=' + course_id +'&batchId=' + batch_id;
    console.log("getHigherEdChildNameList", url);
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}

public getHigherEdChildCourseList(): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetCourseList" +'?Schoolid=' + /*this.schoolId*/1 ;
    console.log("getHigherEdChildCourseList", url);
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}

public getHigherEdChildSemesterList(selectedCourse): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetHiEduSemester" +'?courseid=' + selectedCourse ;
    console.log("getHigherEdChildSemesterList", url);
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}

public getHigherEdChildExamList(selectedCourse,selectedSemester): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetCourseSemesterexam" +'?courseid=' + selectedCourse +'&semesterId='+selectedSemester;
    console.log("getHigherEdChildBatchList", url);
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}

public getHigherEdChildSubjectList(selectedCourse,selectedSemester,selectedExam): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetSemesterModule" +'?courseId=' + selectedCourse +'&semesterId=' + selectedSemester +'&examId=' + selectedExam;
    console.log("getHigherEdChildSubjectList", url);
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
    }

public getHigherEdChildSubSubjectList(selectedCourse,selectedSemester,selectedmodule): Observable<Response> {
let url: string = '' + this.appConstants.baseUrl + "GetHiEduSubSubjects" +'?courseId=' + selectedCourse +'&semesterId=' + selectedSemester +'&subjectId=' + selectedmodule ;
console.log("getHigherEdChildSubSubjectList", url);
return this.httpClient.Get(url)
  .map(this.extractData)
  .catch(this.handleError)
}

//submodule view code
public ShowCourseSubmoduleMapping(): Observable<Response> {
let url: string = '' + this.appConstants.baseUrl + "GetHiEduSubSubjects" +'?courseId=' + /*this.courseid*/1 +'&semesterId=' + /*this.semesterId*/1 +'&subjectId=' + /*this.subjectId*/1 ;
console.log("Url",url)
return this.httpClient.Get(url)
   .map(this.extractData)
   .catch(this.handleError);
}


//post Post Semester Module Year Dinidu
public postSemesterModeuls(deptPayload): Observable<Response> {
let url: string = '' + this.appConstants.baseUrl + "PostSemesterModules";
return this.httpClient.Post(url, deptPayload)
.map(this.extractData)
.catch(this.handleError)
}

// post SubSubject Jaliya
public postHigherHiEduSubSubjectsList(Payload): Observable<Response> {
let url: string = '' + this.appConstants.baseUrl + "PostHiEduSubSubjects";
return this.httpClient.Post(url, Payload)
    .map(this.extractData)
    .catch(this.handleError)
}


// post Course
public postHigherHiEduCourse(Payload): Observable<Response> {
let url: string = '' + this.appConstants.baseUrl + "HiEduCreateCourse";
return this.httpClient.Post(url, Payload)
    .map(this.extractData)
    .catch(this.handleError)
}

 //Get Batch
 public getHigherEdChildBatchList(selectedCourse): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "GetHiEduBatchs" +'?courseid=' + selectedCourse ;
    console.log("getHigherEdChildBatchList", url);
    return this.httpClient.Get(url)
        .map(this.extractData)
        .catch(this.handleError)
}

// Post Semester
public postSemester(payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "PostHiEduSemeter";
    return this.httpClient.Post(url, payload)
        .map(this.extractData)
        .catch(this.handleError)
    }

//POST Batch
public postHigherEdChildBatchList(Payload): Observable<Response> {
    let url: string = '' + this.appConstants.baseUrl + "PostHieduBatchs";
    return this.httpClient.Post(url, Payload)
        .map(this.extractData)
        .catch(this.handleError)
    }

//----------------------------------------------------------------------------------------------------//

private extractData(res: Response) {
    let body = res.json();
    return body;
}
private handleError(error: any) {
    let errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    let err = JSON.parse(error._body);
    return Observable.throw(err);
}
///////////////////////////////////////////////////////////////////////////////////////////////////

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/course/courseH.service.ts